import React, { useState } from "react";
import { Link, Route, Routes, json, useNavigate } from "react-router-dom";
import { LayoutData } from "../Structur/Aconlayout";
import { mainNav } from "./navigation";
//import Nav from "react-bootstrap/Nav";
//import Navbar from "react-bootstrap/Navbar";
//import { Home } from "../Pages/Home";
//import NavDropdown from "react-bootstrap/NavDropdown";
import { LogoImg } from "../Components/LogoImg";
import { Menu, Watermark, Switch, Avatar } from "antd";
import { MailOutlined, AppstoreOutlined } from "@ant-design/icons";
import {
  DashboardOutlined,
  HomeOutlined,
  UserOutlined,
  PoweroffOutlined,
} from "@ant-design/icons/lib/icons";

export const RenderMainMenu = ({ vertikal }) => {
  const { user, checkRoles, checkRole, windowWidth } = LayoutData();

  const navigate = useNavigate();
  const [myTheme, setMyTheme] = useState("light");
  if (user === undefined) user = null;

  function checkMenue(r) {
    if (checkRoles(r.roles)) {
      if (r.notLogin && user && user.isAuthenticated) return null;
      if (!r.isPrivate && r.isMenu) return true;
      if (user && user.isAuthenticated && r.isMenu) return true;
    }
    return false;
  }

  const getRolle = (r) => {
    if (r.roles) return "  " + r.roles.join(", ");
    else return "";
  };

  const getItems = (mainNav, offset) => {
    return mainNav
      .map((r, i) => {
        if (checkMenue(r)) {
          if (r.isDropdown) {
            return {
              label: r.name,
              key: offset + i + ":" + r.path,
              icon: r.icon,
              children: getItems(r.nav, 100 * i),
              title: "?",
            };
          } else
            return {
              label: r.name,
              key: offset + i + ":" + r.path,
              icon: r.icon,
            };
        }
        return null;
      })
      .filter((item) => item !== null);
  };

  const [wconfig, setWconfig] = useState({
    content: "CPW",
    color: "rgba(0, 0, 0, 0.15)",
    fontSize: 6,
    zIndex: 11,
    rotate: -22,
    gap: [10, 10],
    offset: [0, 0],
  });

  const menuOnClick = (e) => {
    //console.log('click', e,e.key.split(':')[1]);
    navigate(e.key.split(":")[1]);
  };

  const changeTheme = (value) => {
    setMyTheme(value ? "dark" : "light");
  };
  const mitSwitch = false;
  const swMargin = 10;

  const PersonPicture = ({ base64Image }) => {
    const src = `data:image/jpeg;base64,${base64Image}`;
    //console.log("XXX  ProfilePicture",base64Image);
    return (
      <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "46px",
        }}
        
        >
        <Avatar
          size={{
            xs: 46,
            sm: 46,
            md: 46,
            lg: 46,
            xl: 46,
            xxl: 46,
          }}
          src={src}
          alt="Profilbild"
          gab={4}
          onClick={()=>{navigate("/homecheck") }}
          style={{ cursor: "pointer" }} 
        />
        </div>
      </>
    );
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "46px",
        }}
      >
        {/* Bereich links mit fester Breite von 120px */}
        {windowWidth >= 450 && (
          <div style={{ width: "120px" }}>
            {/* Platz für zusätzliche Inhalte links */}
            <LogoImg />
          </div>
        )}
        {/* Menübereich in der Mitte */}
        <Menu
          mode="horizontal"
          style={{
            marginLeft: 2,
            marginRight: { swMargin },
            top: 0,
            width: "100%",
            zIndex: 1000,
          }}
          theme={myTheme}
          onClick={menuOnClick}
          items={getItems(mainNav(), 0)}
        ></Menu>

        {user && user.person && user.person.Logo && (
          <PersonPicture base64Image={user.person.Logo} />
        )}

        {/* Bereich rechts mit fester Breite von 60px */}
        {mitSwitch && (
          <div style={{ width: "60px" }}>
            {/* Platz für zusätzliche Inhalte rechts */}
            <Switch
              checked={myTheme === "dark"}
              onChange={changeTheme}
              checkedChildren="Dark"
              unCheckedChildren="Light"
            />
          </div>
        )}
      </div>
    </>
  );
};

/*
    <Watermark content={["CPW"]} width={35} height={30} gap={[20,20]} fontSize={18}>

export const RenderMainMenu = ({ vertikal }) => {
  const { user } = AuthData();

  function checkMenue( r ) {


    if (r.notLogin && user.isAuthenticated) return null; 

    if (!r.isPrivate && r.isMenu) return true;
    if (user.isAuthenticated && r.isMenu) return true;
    return false;
  }

  const GetChildren = ({ nav, parentKey }) => {  
    const children = nav.map((x, j) => {
      if (checkMenue(x)) {
        return (
          <React.Fragment key={`${parentKey}-${j}`}>
            <NavDropdown.Item href={x.path}>{x.name}</NavDropdown.Item>
            {x.hasDivider && <NavDropdown.Divider />}
          </React.Fragment>
        );
      }
      return null;
    });
    return <>{children}</>;
  };

  return (
    <Navbar expand="lg" className="bg-body-tertiary" bg="dark" fixed="top" variant="light">
      <Container style={{ marginLeft: "10px" }}>
        {!vertikal && (
          <Navbar.Brand href="/">
            <LogoImg />
          </Navbar.Brand>
        )}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav variant="pills" className={vertikal ? "flex-column" : "me-auto"} style={{ }} >
            {mainNav.map((r, i) => {
              if (!r.isRight){
              if (r.isDropdown) {
                return (
                  <NavDropdown
                    title={r.name}
                    id="basic-nav-dropdown"
                    key={`nav-link-${i}`}
                  >
                    <GetChildren parentKey={i} nav={r.nav} />
                  </NavDropdown>
                );
              } else {
                if (checkMenue(r)) {
                  return (
                    <Nav.Link key={`nav-link-${i}`} href={r.path}>
                      {r.name}
                    </Nav.Link>
                  );
                } else return null;
              }
            }
            })}
          </Nav>
          <Nav variant="pills" className={vertikal ? "flex-column" : "justify-content-end"} style={{ }} >
            {mainNav.map((r, i) => {
              if (r.isRight){
              if (r.isDropdown) {
                return (
                  <NavDropdown
                    title={r.name}
                    id="basic-nav-dropdown"
                    key={`nav-link-${i}`}
                  >
                    <GetChildren parentKey={i} nav={r.nav} />
                  </NavDropdown>
                );
              } else {
                if (checkMenue(r)) {
                  return (
                    <Nav.Link key={`nav-link-${i}`} href={r.path}>
                      {r.name}
                    </Nav.Link>
                  );
                } else return null;
              }
            }
            })}
          </Nav>

        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
*/

/*
items={[
  { label: "Home", key: "/", icon: <HomeOutlined /> },
  {
    label: "Dashboard",
    key: "/aconkunden",
    icon: <DashboardOutlined />,
  },
  {
    label: "User List",
    key: "/alleusers",
    icon: <UserOutlined />,
    children: [
      { label: "AccountEdit 1", key: "/accountEdit" },
      { label: "Detail 2", key: "/" },
      { label: "Detail 3", key: "/" },
      { label: "Detail 4", key: "/" },
      { label: "Detail 5", key: "/" },
    ],
  },
  { label: "Login", key: "/login", icon: <PoweroffOutlined /> },
  {
    label: "Logout",
    key: "/logout",
    icon: <PoweroffOutlined />,
    danger: true,
  },
]}

*/
